import Utils from '../../framework/utils.js';

// JobPostView
// ===========
//
// Represents a row in the job listing table

export default class JobPostView extends EventTarget {
  constructor(tmpl, model) {
    super();

    this.dom = tmpl;
    this.id = model.get('id');
    this.render(model);
  }

  render(model) {
    this.dom.querySelector('.careers-table_row_position').insertAdjacentHTML('beforeend', `<a href="${model.getUrl()}" target="_blank">${model.get('name')}</a>`);
    this.dom.querySelector('.careers-table_row_brand').innerHTML = model.getBrandLabel();
    this.dom.querySelector('.careers-table_row_type').innerHTML = model.getEmployeeTypeLabel();
    this.dom.querySelector('.careers-table_row_department').innerHTML = model.getDepartmentLabel();
    this.dom.querySelector('.careers-table_row_location').innerHTML = model.getLocationLabel();
  }
}